const ADS_DATA_LABEL = {
  status: "상태",
  startDate: "광고 생성일",
  budget: "월 희망 예산",
  roas: "광고수익률",
  revenue: "매출",
  cost: " 광고비용",
};

export default ADS_DATA_LABEL;
